/**
 * The Pipelines (CDP) destination catalog: the integrations a workspace can add
 * as a destination, and each one's manifest. Served by the CDP backend at
 * `/cdp/api/workspaces/{id}/available_destinations` and
 * `/cdp/api/workspaces/{id}/action_destinations/{optionId}/manifest`, which has
 * no OpenAPI spec, so the client is hand-written (see `client.ts`).
 */

export const DestinationMode = {
  Cloud: 'cloud',
  Direct: 'device',
  Javascript: 'legacy',
  // Temporary while we build support for direct ETL destinations.
  StaticEtl: 'static-etl',
} as const;
export type DestinationMode = (typeof DestinationMode)[keyof typeof DestinationMode];

export interface AvailableDestination {
  option_id: string;
  icon: string;
  name: string;
  content: string;
  learn_more_url: string;
  category: string;
  mode: DestinationMode;
  experimental: boolean;
  premium?: boolean;
  beta: boolean;
  connection_type: string;
}

export const cdpDestinationOptionKeys = {
  all: (workspaceId: number) => ['workspace', workspaceId, 'cdp-destination-option'] as const,
  lists: (workspaceId: number) => [...cdpDestinationOptionKeys.all(workspaceId), 'list'] as const,
  manifest: (workspaceId: number, optionId: string) =>
    [...cdpDestinationOptionKeys.all(workspaceId), 'manifest', optionId] as const,
  /** The key an inactive read parks on. Outside the workspace namespace, and never written. */
  inactive: (read: string) => ['cdp-destination-option', 'inactive', read] as const,
};
